import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Login from '../../components/auth/Login';
import Register from '../../components/auth/Register';
import PassRecovery from '../../components/auth/PassRecovery';
import ChangePass from '../../components/auth/ChangePass';
import style from './auth.module.scss';
// import myVideo from '../../img/Logo.mov';
import FairEntry from '../../components/auth/FairEntry';

const AnimatedLogo = () => {
  const { logo } = style;
  return (
    <div className={logo}>
      {/* <video loop autoPlay muted>
        <source src={myVideo} type="video/mp4" />
      </video> */}
    </div>
  );
};

const signPage = () => {
  const { pos } = style;

  let { path } = useRouteMatch();

  return (
    <div>
      {/* <div className={bg}></div> */}
      <Switch>
        <Route path={`${path}/register`}>
          <AnimatedLogo />
          <div className={pos}>
            <Register />
          </div>
        </Route>
        <Route path={`${path}/passRecovery/:token`}>
          <AnimatedLogo />
          <div>
            <ChangePass />
          </div>
        </Route>
        <Route path={`${path}/passRecovery`}>
          <AnimatedLogo />
          <div>
            <PassRecovery />
          </div>
        </Route>
        <Route path={`${path}/entry`}>
          <FairEntry />
        </Route>
        <Route path={`${path}`} exact>
          {/* <AnimatedLogo /> */}
          <div>
            <Login />
          </div>
        </Route>
      </Switch>
    </div>
  );
};

export default signPage;
